export default __webpack_public_path__ + "static/media/direct-download (1).c21672c5.png";